import { Component } from '@angular/core';

@Component({
  selector: 'app-onboard-layout',
  templateUrl: './onboard-layout.component.html',
  styleUrls: ['./onboard-layout.component.scss'],
  host: { '[attr.tabindex]': '-1' },
  standalone: false,
})
export class OnboardLayoutComponent {}
